import { Icon } from "@iconify/react";
import SearchIcon from "../../assets/SearchIcon";

export const InputFilter = ({ value, handleChange = () => {} }) => {
  return (
    <div className="my-1 flex items-center w-[100%]">
      <form
        className="px-3 py-2 flex gap-2  rounded-md text-sm w-full border border-[##E1E1E1] h-[35px] bg-[#FAFAFB] text-[#4A4E5A] search"
        onSubmit={(e) => e.preventDefault()}
      >
        <Icon
          icon="iconamoon:search-thin"
          style={{ width: "20px", height: "15px" }}
        />
        <input
          type="text"
          placeholder="Search"
          className="w-full bg-transparent border-0 outline-0"
          autoFocus
          value={value}
          onChange={(e) => handleChange(e.target.value)}
        />
        <div>
          <SearchIcon />
        </div>
      </form>
    </div>
  );
};
